/* eslint-disable global-require */
module.exports = {
	gp: require("./gp"),
	sg: require("./sg"),
	gn: require("./gn"),
	om: require("./om"),
	pm: require("./pm"),
};
